<template>
  <div class="scroll-animate" :class="{ 'is-visible': isVisible }" :style="{
      transitionDelay: delay + 'ms',
      transitionDuration: duration + 'ms'
    }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    // 动画延迟时间（毫秒）
    delay: {
      type: [Number, String],
      default: 50
    },
    // 动画持续时间（毫秒）
    duration: {
      type: [Number, String],
      default: 500
    },
    // 动画效果
    effect: {
      type: String,
      default: 'fade-up',
      validator: value => ['fade-up', 'fade', 'slide-right', 'slide-left'].includes(value)
    },
    // 触发阈值 (0-1)
    threshold: {
      type: [Number, Array],
      default: () => [0, 0.2, 0.4, 0.6, 0.8, 1]
    },
    // 视口边距
    rootMargin: {
      type: String,
      default: '0px 0px -10% 0px' // 元素进入视口10%时触发
    },
    // 仅触发一次
    once: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: false,
      observer: null
    };
  },
  mounted() {
    // 初始化 Intersection Observer
    this.initObserver();
  },
  beforeDestroy() {
    // 清理 observer
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initObserver() {
      const options = {
        root: null,
        rootMargin: this.rootMargin,
        threshold: this.threshold
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 元素进入视口
            this.isVisible = true;

            // 如果只触发一次，停止观察
            if (this.once) {
              this.observer.unobserve(entry.target);
            }
          } else if (!this.once) {
            // 元素离开视口
            this.isVisible = false;
          }
        });
      }, options);

      // 开始观察元素
      this.observer.observe(this.$el);
    }
  }
};
</script>

<style scoped>
.scroll-animate {
  opacity: 0;
  transition: all 0.5s ease;
  transform: translateY(30px);
  width: 100%;
}

.scroll-animate.is-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 其他动画效果 */
.scroll-animate.fade {
  transform: translateY(0);
}

.scroll-animate.slide-right {
  transform: translateX(-30px);
}

.scroll-animate.slide-right.is-visible {
  transform: translateX(0);
}

.scroll-animate.slide-left {
  transform: translateX(30px);
}

.scroll-animate.slide-left.is-visible {
  transform: translateX(0);
}
</style>
